module.exports = __webpack_public_path__ + "static/media/POTE1_LADO.efdbc79e.png";